<template>
  <div ref="pdf">
    <iframe :src="fileUrl" frameborder="0" width="100%" height="600px" border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    fileUrl: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom_ {
  width: 100%;
  height: 1.07rem;
  background: #fff;
  padding: 0.4rem 0;
  .btn_ {
    width: 80%;
    margin:0 auto;
    line-height: 1.07rem;
    background: #1b7cf8;
    border-radius: 0.63rem;
    font-size: 0.4rem;
    font-weight: bold;
    color: #ffffff;
  }
}
</style>
